/**
 * Arverett Module Description
 * Master Grade modul for arverett
 */
import { MasterGradeBadge, ModuleSection, FeatureList, PrivacyNotice } from '../../shared';

export const ARVERETT_CONFIG = {
  id: 'arverett',
  title: 'Arverett',
  status: 'active',
  badge: 'Master',
  
  masterDescription: "er RettVerks mest avanserte nivå. Den kombinerer full faglig dekning innen arverett med lokal AI-drevet dokumentanalyse, automatisk beregning av pliktdelsarv og generering av strukturerte testamentutkast. Modulen er utviklet for å gi deg et helhetlig verktøy for testament, fremtidsfullmakt og arveoppgjør.",
  
  aboutModule: "Arverett-modulen gir deg verktøy for å opprette testament, fremtidsfullmakt og gjennomføre privat skifte, basert på arveloven av 2019 og vergemålsloven.",
  
  features: [
    "Digital testament-editor med automatisk validering av vitnekrav og pliktdelsarv-kontroll",
    "Fremtidsfullmakt-generator iht. Statsforvalterens krav og vergemålsloven kap. 10",
    "Privat skifte-veiviser med alle formelle steg fra dødsfall til utlodningslag",
    "Kalkulator for pliktdelsarv (2/3 av formuen, maks 15G per barn) og minstearv til ektefelle",
    "Gjeldsbrev og gavebrev for forskudd på arv med korrekt dokumentasjon"
  ],
  
  privacyText: "All analyse og behandling skjer lokalt på din enhet. Testamenter og personlige dokumenter lastes ikke opp, lagres ikke på servere og deles ikke med RettVerk."
};

export function ArverettDescription() {
  const config = ARVERETT_CONFIG;
  
  return (
    <div className="space-y-5 max-h-[65vh] overflow-y-auto pr-2">
      <MasterGradeBadge description={config.masterDescription} />
      
      <ModuleSection icon="📋" title="Om modulen">
        <p className="text-sm text-[var(--text-muted)] leading-relaxed">
          {config.aboutModule}
        </p>
      </ModuleSection>
      
      <ModuleSection icon="⚙️" title="Funksjoner">
        <FeatureList features={config.features} />
      </ModuleSection>
      
      <PrivacyNotice text={config.privacyText} />
    </div>
  );
}

export default ArverettDescription;
